import React, {Fragment} from "react";
import './AdminDashboard.scss'
import PurpleTab from "./PurpleTab";
import DashboardNewsTable from "root/s360components/DashboardNewsTable";
import DashboardAttendanceSummary from "root/s360components/DashboardAttendanceSummary";
import UsageGraphSelector from "root/s360components/UsageGraphSelector";
import AdminUsersDashboardProvider from "root/s360components/AdminUsersDashboardProvider";
import AdminDashboardLinks from "root/s360components/AdminDashboardLinks";


export const ADMIN_USER_TYPES = {
    TEACHER: 'teacher',
    SCHOOL_ADMIN: 'schoolAdmin',
    GOVERNOR: 'governor'
}

const AdminUsersDashboard = (props) =>
{

    const permissions =
        {
            [ADMIN_USER_TYPES.SCHOOL_ADMIN]:
                {
                    showAppsAndShortcuts: true,
                    showNews: true,
                    showPupilActivity: true,
                    showAttendanceSummary: true,
                },
            [ADMIN_USER_TYPES.GOVERNOR]:
                {
                    showAppsAndShortcuts: true,
                    showNews: true,
                    showPupilActivity: false,
                    showAttendanceSummary: false,
                },
            [ADMIN_USER_TYPES.TEACHER]:
                {
                    showAppsAndShortcuts: true,
                    showNews: true,
                    showPupilActivity: true,
                    showAttendanceSummary: true,
                }
        };


    const pageContent = (props) =>
    {
        return (
                <div className='admin-dash-wrapper'>
                    <div className='admin-dash-wrapper-left'>
                        <div className='column-wrapper'>
                            {permissions[props.user_type].showAppsAndShortcuts && <PurpleTab title='APPS and School360 Shortcuts'>
                                <AdminUsersDashboardProvider school_id={props.school_id}>
                                    <AdminDashboardLinks school_id={props.school_id} user_id={props.user_id} user_type={props.user_type}
                                                         concern_report_access={props.concern_report_access} eschools_admin={props.eschools_admin}
                                                         online_safety_audit_enabled={props.online_safety_audit_enabled}/>
                                </AdminUsersDashboardProvider>
                            </PurpleTab>}
                        </div>
                        {permissions[props.user_type].showPupilActivity &&<div className='column-wrapper'>
                             <UsageGraphSelector school_id={props.school_id}/>
                        </div>}
                    </div>
                    <div className='admin-dash-wrapper-right'>
                        {permissions[props.user_type].showNews && <DashboardNewsTable school_id={props.school_id}/>}

                        {permissions[props.user_type].showAttendanceSummary && <DashboardAttendanceSummary school_id={props.school_id}/>}
                    </div>
                </div>
        )
    }

    return pageContent(props);
};

export default AdminUsersDashboard;
